import { getRequestCommonParameters } from '@lib/core/service/requests/api';

export const commentsApiUrlCreator = () => {
  const { retailerSlug, retailerLocationSlug } = getRequestCommonParameters();
  return `/${retailerSlug}/${retailerLocationSlug}/comments/product/`;
};
